/* tslint:disable */
/* eslint-disable */
/**
 * Resource server API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface PatientOnListDto
 */
export interface PatientOnListDto {
    /**
     * 
     * @type {string}
     * @memberof PatientOnListDto
     */
    'birthDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientOnListDto
     */
    'firstName'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof PatientOnListDto
     */
    'hasNeuroscreen': boolean;
    /**
     * 
     * @type {number}
     * @memberof PatientOnListDto
     */
    'id'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof PatientOnListDto
     */
    'isDeceased': boolean;
    /**
     * 
     * @type {string}
     * @memberof PatientOnListDto
     */
    'lastName'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientOnListDto
     */
    'leadDoctorFirstName'?: string;
    /**
     * 
     * @type {number}
     * @memberof PatientOnListDto
     */
    'leadDoctorId'?: number;
    /**
     * 
     * @type {string}
     * @memberof PatientOnListDto
     */
    'leadDoctorLastName'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientOnListDto
     */
    'login': string;
    /**
     * 
     * @type {string}
     * @memberof PatientOnListDto
     */
    'publicId'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientOnListDto
     */
    'sex'?: PatientOnListDtoSexEnum;
}

/**
    * @export
    * @enum {string}
    */
export enum PatientOnListDtoSexEnum {
    Male = 'MALE',
    Female = 'FEMALE'
}


